module.exports = __webpack_public_path__ + "img/a-propos-prestations-3.4b2420ef.webp";